import { SubscriptionsTemplatesHeader } from './PageHeader';
import { SubscriptionsTemplatesContent } from './Content';

export function SubscriptionsTemplatePage() {
  return (
    <>
      <SubscriptionsTemplatesHeader />
      <SubscriptionsTemplatesContent />
    </>
  );
}
